/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<defs/><path pid="0" id="plus" class="cls-1" d="M1605 29h-8v-8h-2v8h-8v2h8v8h2v-8h8v-2z" transform="translate(-1587 -21)"/>'
  }
})
